import React, { useState, useEffect } from 'react';

type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

type CountdownTimerProps = {
  targetDate: Date;
};

export const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = targetDate.getTime() - new Date().getTime();
      
      if (difference > 0) {
        const secondsInMs = 1000;
        const minutesInMs = secondsInMs * 60;
        const hoursInMs = minutesInMs * 60;
        const daysInMs = hoursInMs * 24;
        
        const days = Math.floor(difference / daysInMs);
        const hours = Math.floor((difference % daysInMs) / hoursInMs);
        const minutes = Math.floor((difference % hoursInMs) / minutesInMs);
        const seconds = Math.floor((difference % minutesInMs) / secondsInMs);
        
        setTimeLeft({ days, hours, minutes, seconds });
      }
    };
    
    calculateTimeLeft();
    
    const timer = setInterval(calculateTimeLeft, 1000);
    
    return () => clearInterval(timer);
  }, [targetDate]);

  const timeUnits = [
    { value: timeLeft.days, label: 'Days' },
    { value: timeLeft.hours, label: 'Hours' },
    { value: timeLeft.minutes, label: 'Min' },
    { value: timeLeft.seconds, label: 'Sec' }
  ];

  const formatNumber = (num: number) => {
    return num.toString().padStart(2, '0');
  };

  return (
    <div className="flex flex-row items-center justify-center space-x-2 md:space-x-4 md:translate-y-[60px]">
      {timeUnits.map((unit, index) => (
        <div key={index} className="flex flex-col items-center">
          <div className="flex space-x-1">
            {formatNumber(unit.value).split('').map((digit, i) => (
              <div
                key={i}
                className="w-6 h-9 md:w-6 md:h-8 bg-gradient-to-b from-red-600 to-red-800 rounded-lg flex items-center justify-center shadow-lg animate-[pulse_1s_ease-in-out_infinite]"
              >
                <span className="text-white text-base md:text-lg font-bold">{digit}</span>
              </div>
            ))}
          </div>
          <span className="text-white text-xs md:text-sm mt-1">{unit.label}</span>
        </div>
      ))}
    </div>
  );
};
